import styled from 'styled-components';

export const SectionWrap = styled.div `
    background: ${props => props.theme.colors.themeColor};
    padding-top: 60px;
    padding-bottom: 30px;
`;
 